export default "__VITE_ASSET__8ypmDLGO__"